function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import mapValues from 'lodash/mapValues';
import join from 'lodash/join';
import last from 'lodash/last';
import find from 'lodash/find';
import flow from 'lodash/flow';
import reduce from 'lodash/reduce';
import toLower from 'lodash/toLower';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import partial from 'lodash/partial';
import { formatTimestamp } from 'helpers/datetime';
import { toMedication } from 'helpers/relatedData';
import messages from '../messages';
import { translateLocation } from './index';
const resourceTypesForBgDataReport = [
    'Nutrition',
    'Activity',
    'Note',
    'Medication',
    'Meal'
];
const resourceTypesForDailyLogReport = [
    'Nutrition',
    'Activity',
    'Medication'
];
const filterByResourceTypes = (timeSeriesResources, resourceTypesForRelatedValue)=>filter(timeSeriesResources, ({ resourceType })=>includes(resourceTypesForRelatedValue, resourceType));
const groupedByFormatedTimestamp = (timeSeriesResources)=>timeSeriesResources.reduce((acc, item)=>{
        const key = formatTimestamp(item.timestamp, 'L LTS');
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
const groupedByTimestamp = (timeSeriesResources)=>timeSeriesResources.reduce((acc, item)=>{
        const key = item.timestamp;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
export class TimeSeriesResourcesHelper {
    translateToBgDataReportRelatedValues(timeSeriesResources) {
        return flow([
            partial(filterByResourceTypes, partial.placeholder, resourceTypesForBgDataReport),
            groupedByFormatedTimestamp,
            this.calculateByResourceTypeForBgDataReport
        ])(timeSeriesResources);
    }
    translateToDailyLogReportRelatedValues(timeSeriesResources) {
        return flow([
            partial(filterByResourceTypes, partial.placeholder, resourceTypesForDailyLogReport),
            groupedByTimestamp,
            this.calculateByResourceTypeForDailyLogReport
        ])(timeSeriesResources);
    }
    constructor(intl, locations, countriesNames){
        _define_property(this, "translateActivity", (timeSeriesResource)=>{
            const { intensity, name, value } = timeSeriesResource;
            if (!name) {
                return '';
            }
            if (intensity) {
                const intensityMessage = this.intl.formatMessage(messages.activity.intensity[toLower(intensity)]);
                return `${intensityMessage} ${name} ${value} ${this.timeUnitMessage}`;
            }
            return `${name} ${value} ${this.timeUnitMessage}`;
        });
        _define_property(this, "calculateByResourceTypeForBgDataReport", (groupedTimeSeriesResources)=>mapValues(groupedTimeSeriesResources, (timeSeriesResources)=>reduce(timeSeriesResources, (acc, timeSeriesResource)=>{
                    switch(timeSeriesResource.resourceType){
                        case 'Nutrition':
                            if (timeSeriesResource.type === 'Carbohydrates') {
                                acc.foodValue = (acc.foodValue || 0) + timeSeriesResource.value;
                                const mealId = last(timeSeriesResource.parents);
                                const meal = find(timeSeriesResources, {
                                    id: mealId
                                });
                                timeSeriesResource.locationLabelUID = meal ? meal.locationLabelUID : null;
                            }
                            break;
                        case 'Activity':
                            {
                                const activity = this.translateActivity(timeSeriesResource);
                                if (acc.activity && activity) {
                                    acc.activity = join([
                                        acc.activity,
                                        activity
                                    ], ', ');
                                } else {
                                    acc.activity = activity !== undefined ? activity : acc.activity;
                                }
                                break;
                            }
                        case 'Note':
                            {
                                const note = timeSeriesResource.content;
                                if (acc.note && note) {
                                    acc.note = join([
                                        acc.note,
                                        note
                                    ], ', ');
                                } else {
                                    acc.note = note !== undefined ? note : acc.note;
                                }
                                break;
                            }
                        case 'Medication':
                            {
                                const medication = toMedication(timeSeriesResource);
                                if (acc.medication && medication) {
                                    acc.medications = join([
                                        acc.medications,
                                        timeSeriesResource.content
                                    ], ', ');
                                } else {
                                    acc.medications = medication !== undefined ? medication : acc.medications;
                                }
                                break;
                            }
                        default:
                            break;
                    }
                    if (timeSeriesResource.locationLabelUID && this.locations && this.locations.length) {
                        acc.location = translateLocation(timeSeriesResource.locationLabelUID, this.locations, this.countriesNames);
                    }
                    acc.dataSource = 'Manual';
                    return acc;
                }, {})));
        _define_property(this, "calculateByResourceTypeForDailyLogReport", (groupedTimeSeriesResources)=>mapValues(groupedTimeSeriesResources, (timeSeriesResources)=>{
                const timestamp = timeSeriesResources ? timeSeriesResources[0].timestamp : undefined;
                return reduce(timeSeriesResources, (acc, timeSeriesResource)=>{
                    switch(timeSeriesResource.resourceType){
                        case 'Nutrition':
                            if (timeSeriesResource.type === 'Carbohydrates') {
                                acc.foodValue = (acc.foodValue || 0) + timeSeriesResource.value;
                            }
                            break;
                        case 'Activity':
                            {
                                acc.activityValue = (acc.activityValue || 0) + (timeSeriesResource.value || 0);
                                break;
                            }
                        case 'Medication':
                            {
                                const { basalFlag, bolusFlag, value } = timeSeriesResource;
                                if (bolusFlag) {
                                    acc.medicationFastValue = (acc.medicationFastValue || 0) + value;
                                } else if (basalFlag) {
                                    acc.medicationLongValue = (acc.medicationLongValue || 0) + value;
                                }
                                break;
                            }
                        default:
                            break;
                    }
                    return acc;
                }, {
                    timestamp
                });
            }));
        this.intl = intl;
        if (intl) {
            this.timeUnitMessage = this.intl.formatMessage(messages.labels.min);
        }
        this.locations = locations;
        this.countriesNames = countriesNames;
    }
}
